import React from 'react';
import styled from 'styled-components';
import iphone5 from 'images/iphone-5-portrait.png';
import iphone1 from 'images/iphone-1-portrait.png';
import iphone6 from 'images/iphone-6-portrait.png';
import {ScreenSizes} from '../../../types/responsive';

const Screenshots = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  overflow: visible;
  margin: 0 auto 100px;

  @media (max-width: ${ScreenSizes.sm}) {
    gap: 20px;
  }
  &:before {
    display: block;
    content: '';
    position: absolute;
    transform: skew(0, -15deg);
    top: 15%;
    right: 0;
    left: 0;
    bottom: 0;
    background-image: linear-gradient(40deg, #12e0c2 0%, #7984d9 90%);
    z-index: -1;
    height: 65%;
  }
`;

const Screenshot = styled.img`
  width: 260px;
  height: auto;
  flex-shrink: 0;
  @media (max-width: ${ScreenSizes.sm}) {
    width: 170px;
  }
  @media (max-width: ${ScreenSizes.xs}) {
    width: 130px;
  }
`;

export const HorizontalScreenshotsNew: React.FC = () => {
  return (
    <Screenshots>
      <Screenshot src={iphone5} />
      <Screenshot src={iphone1} />
      <Screenshot src={iphone6} />
    </Screenshots>
  );
};
